import type { UpdateStageOperationPayload } from '../ProcessTemplateV2/types';

const toHourValue = (value: number) => {
  const remainder = value % 24;
  return remainder < 0 ? remainder + 24 : remainder;
};

export function buildDraggedOperationTimingUpdate(
  newStart: number,
  _newEnd: number,
  stageStartDay: number,
): UpdateStageOperationPayload {
  const newAbsoluteDay = Math.floor(newStart / 24);
  const newRecommendedTime = toHourValue(newStart);
  const newOperationDay = newAbsoluteDay - stageStartDay;

  return {
    operationDay: newOperationDay,
    recommendedTime: newRecommendedTime,
    recommendedDayOffset: 0,
  };
}
